<template>
    <section class="plugin-home-about">
        <div class="plugin-home-about__container">
            <div class="plugin-home-about__content">
                <div class="plugin-home-about__content-logo">
                    <ui-logo-text />
                </div>
                <div class="plugin-home-about__content-text"
                     v-html="text"
                />
                <div class="plugin-home-about__content-image-mobile"
                     v-bind:style="backgroundStyle"
                />
            </div>
            <div class="plugin-home-about__image"
                 v-bind:style="backgroundStyle"
            >
            </div>
        </div>
    </section>
</template>

<script>
import utils from '~/utils';

export default {
    name: 'plugin-home-about-v2',
    props: {
        image: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
    },
    computed: {
        backgroundStyle() {
            if (!this.image) {
                return null;
            }
            const resize = utils.common.getResize({
                1920: 43,
                1023: 100,
            });
            // return { backgroundImage: `url(${utils.common.injectResize(this.image, resize)})` };
            return { backgroundImage: `url(${this.image})` };
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-about {
    .container-landing();

    display: flex;
    align-items: center;
    min-height: 780px;

    &__container {
        position: relative;
        max-width: @landing-max-width;
        margin: 0 auto;
    }
    &__content {
        position: relative;

        display: flex;
        flex-direction: column;
        gap: 48px;

        width: 86%;
        padding: 74px;
        padding-right: 370px;

        border: 1px solid @color-gray-light-secondary;
        border-radius: @border-radius-xxxl;

        background-color: white;

        overflow: hidden;

        &-logo {
            font-size: 36px;
        }
        &-text {
            font-size: 36px;
            line-height: 46px;
            font-weight: normal;

            white-space: pre-line;

            color: @color-gray-darker;
            /deep/ p {
                margin: 0;
            }
            /deep/ strong {
                font-weight: bold;
            }
        }
        &-image-mobile {
            display: none;
        }
    }
    &__image {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;

        width: 555px;
        height: 780px;
        max-width: 100%;

        background-size: contain;
        background-position: left;
        background-repeat: no-repeat;
    }

    @media @media-lg-down {
        min-height: auto;
        &__content {
            width: 100%;
            padding: 37px;
            padding-bottom: 0;
            border-radius: @border-radius-xxl;
            text-align: center;

            &-image-mobile {
                display: block;
                width: 100%;
                height: 250px;

                background-size: 250px;
                background-position: top;
                background-repeat: no-repeat;
            }
        }
        &__image {
            display: none;
        }
    }

    @media @media-sm-down {
        min-height: auto;
        &__content {
            gap: 6px;
            padding: 24px 24px 0 24px;

            &-logo {
                font-size: 20px;
            }
            &-text {
                .typography-small();
            }
        }
    }
}
</style>
